import { Button, List, IconButton, Tooltip } from '@mui/material';
import {
  AccessTime,
  CalendarMonth,
  Delete,
  Place,
} from '@mui/icons-material';
import { sortBy, dropRight } from 'lodash';
import { useTranslation } from 'next-i18next';
import CardOwner from '../CardOwner/CardOwner';
import classNames from 'classnames';
import dayjs from 'dayjs';
import React from 'react';
const CartProduct = ({
  item,
  user,
  cart,
  loading,
  handleOpenDialog,
  setIdsToRemove,
  setAllowPayment,
}) => {
  const { t } = useTranslation();
  return (
    <div
      className={classNames('relative', {
        'animate-pulse opacity-30 duration-75 ease-in-out': loading,
      })}
    >
      {item?.list.map(
        ({ name, city, address, products, subtotal, ids }) => {
          return (
            <div
              key={name}
              className={classNames(
                'relative flex flex-col',
                'bg-white shadow-lg rounded-[4px] w-full md:w-[550px]',
                'mb-4 space-y-2 p-4 lg:p-8',
              )}
            >
              {/* Delete Product Button */}
              <Button
                size="small"
                variant="text"
                color="error"
                onClick={() => {
                  setIdsToRemove(ids);
                  handleOpenDialog();
                }}
                className={classNames(
                  'text-xs md:flex',
                  'absolute right-4 top-5 hidden',
                )}
              >
                {t('buttons.delete')}
              </Button>

              <span
                className={classNames(
                  'md:max-w-md md:text-xl',
                  'flex body font-bold uppercase',
                )}
              >
                {name}
              </span>

              <List dense={true}>
                {address && (
                  <div>
                    <Place
                      fontSize="small"
                      className="font-semibold text-primary mr-7"
                    />
                    <span className="text-sm font-bold body">
                      {city}
                    </span>
                  </div>
                )}

                <div>
                  <CalendarMonth
                    fontSize="small"
                    className="font-semibold text-primary mr-7"
                  />
                  <span className="text-sm font-bold body">
                    {dayjs(item.date).format('LL')}
                  </span>
                </div>
              </List>

              {sortBy(products, 'slot').map(({ slot, slots }) => {
                const isSingleProduct = products?.length === 1;

                return (
                  <div
                    key={slot}
                    ref={(node) => {
                      // Workaround to set rules without ts error
                      if (node && isSingleProduct) {
                        node.style.cssText = `margin-top: -7px !important;`;
                      }
                    }}
                  >
                    <div
                      className={classNames({
                        'pt-0': isSingleProduct,
                      })}
                    >
                      <AccessTime
                        fontSize="small"
                        className="font-semibold text-primary mr-7"
                      />
                      <span className="text-sm font-bold body">
                        {slot.split(':')?.length > 2
                          ? dropRight(slot.split(':')).join(':')
                          : slot}
                      </span>
                    </div>

                    <List dense={true}>
                      {slots.map(({ type, types }) => {
                        const getLastItem = types[types.length - 1];

                        const getProductCards = types?.filter(
                          ({ product, id }) => product?.isCard,
                        );

                        // const typesTotal = types.reduce(
                        //   (acc, { product: { price_sale: $ } }) =>
                        //     acc + $,
                        //   0,
                        // );

                        const documentRequired =
                          getLastItem?.product?.reductions?.length;

                        return (
                          <div key={type}>
                            <div className="relative">
                              <IconButton
                                edge="end"
                                aria-label="delete"
                                onClick={() => {
                                  setIdsToRemove(getLastItem?.id);
                                  handleOpenDialog();
                                }}
                                className="absolute right-1"
                              >
                                <Delete fontSize="small" />
                              </IconButton>
                              <span>
                                <span className="font-semibold text-primary mr-8">
                                  {types?.length} x
                                </span>
                                <Tooltip
                                  title={
                                    documentRequired && (
                                      <span className="text-xs">
                                        {t('cart.alert_reductions')}
                                      </span>
                                    )
                                  }
                                >
                                  <span className="text-sm font-bold body">
                                    {type}
                                    {documentRequired && (
                                      <span className="mx-2">
                                        *
                                      </span>
                                    )}
                                  </span>
                                </Tooltip>
                              </span>
                            </div>

                            {user &&
                              user?.logged &&
                              getProductCards?.length > 0 && (
                                <ul className="mb-6 ">
                                  {getProductCards?.map(
                                    (
                                      {
                                        holder_first_name,
                                        holder_last_name,
                                        id,
                                      },
                                      index,
                                    ) => {
                                      return (
                                        <CardOwner
                                          key={index}
                                          id={id}
                                          setAllowPayment={
                                            setAllowPayment
                                          }
                                          index={index + 1}
                                          user={user}
                                          cart={cart}
                                          types={types}
                                          name={
                                            holder_first_name || ''
                                          }
                                          surname={
                                            holder_last_name || ''
                                          }
                                        />
                                      );
                                    },
                                  )}
                                </ul>
                              )}
                          </div>
                        );
                      })}
                    </List>
                  </div>
                );
              })}

              <div
                className={classNames(
                  'border-t-2 pt-2 border-dotted',
                  'flex items-center justify-between',
                )}
              >
                <Button
                  variant="text"
                  onClick={() => {
                    try {
                      setIdsToRemove(ids);
                      handleOpenDialog();
                    } catch (error) {
                      console.error(
                        'cartList.buttons.delete',
                        error,
                      );
                    }
                  }}
                  color="error"
                >
                  <span>{t('buttons.delete')}</span>
                </Button>
                <span className={'text-xl font-bold'}>
                  {subtotal} euro
                </span>
              </div>
            </div>
          );
        },
      )}
    </div>
  );
};

export default CartProduct;
